module.exports = __webpack_public_path__ + "img/icon-sb-mattress-extra-firm-40_v1.22ecb5c.svg";